import { GenericLazyString } from '@eventbrite/i18n';
import { css } from 'emotion';
import React from 'react';
import { ISeatInfo } from '../../types';
import FloatingDialog, {
    IFloatingDialogMargins,
} from '../common/floating-dialog';
import SelectedSeatLine from './selected-seat-line';
import TicketLine from './ticket-line';
import TicketReleaseHoldLine from './ticket-release-hold-line';

interface ITicketFloatingDialog {
    arrowDialog?: 'top' | 'bottom';
    isDisplay?: boolean;
    position: { x: number; y: number };
    positionType: 'arrow' | 'corner';
    removePanel?: () => void;
    viewport: { width: number; height: number };
    margins: IFloatingDialogMargins;
    handleSelector: (_: any) => void;
    isHold?: boolean;
    showSeatInfo?: boolean;
    seatInfo: ISeatInfo;
    tickets: {
        ticketName: string;
        price: string | GenericLazyString;
        variantId: string;
        conflictingPayment?: boolean;
        complimentaryOrder: boolean;
        selectSeatsLabel?: string;
    }[];
    verticalOffset?: number;
    onReleaseAction?: (_: any) => void;
}

const TicketFloatingDialog = ({
    arrowDialog,
    seatInfo,
    handleSelector,
    isDisplay,
    isHold,
    margins,
    onReleaseAction,
    position,
    positionType,
    removePanel,
    tickets = [],
    viewport,
    verticalOffset,
    showSeatInfo,
}: ITicketFloatingDialog): React.ReactElement => (
    <FloatingDialog
        arrowDialog={arrowDialog}
        position={position}
        isDisplay={isDisplay}
        removePanel={removePanel}
        positionType={positionType}
        viewport={viewport}
        margins={margins}
        verticalOffset={verticalOffset}
    >
        {showSeatInfo && (
            <div data-testid="selected-seat-line">
                <SelectedSeatLine seatInfo={seatInfo} data-testid="" />
            </div>
        )}
        <div
            className={css({
                overflowY: 'auto',
                maxHeight: '228px',
            })}
        >
            {tickets.map(
                (
                    {
                        price = '',
                        ticketName = '',
                        variantId = '',
                        conflictingPayment = false,
                        complimentaryOrder = false,
                        selectSeatsLabel = '',
                    },
                    index,
                ) => {
                    const content = (
                        <div key={ticketName} data-testid="ticket-line">
                            <TicketLine
                                handleSelector={handleSelector}
                                seatInfo={seatInfo}
                                info={{
                                    ticketName,
                                    price,
                                    variantId,
                                    conflictingPayment,
                                    complimentaryOrder,
                                    selectSeatsLabel,
                                }}
                                showDivider={index != 0}
                            />
                        </div>
                    );

                    return content;
                },
            )}
        </div>
        {isHold && onReleaseAction ? (
            <div data-testid="hold-line">
                <TicketReleaseHoldLine clickAction={onReleaseAction} />
            </div>
        ) : undefined}
    </FloatingDialog>
);

export default TicketFloatingDialog;
